import "./App.css"
import JOSMLogo from "./assets/JOSM_logo.png"
import GPodcasts from "./assets/GooglePodcasts.png"
import Youtube from "./assets/Youtube.png"
import AppleMusic from "./assets/AppleMusic.png"
import Spotify from "./assets/Spotify.png"
import Cross from "./assets/Cross.png"
export default function Podcast(props) {
    console.log(props)
    function backToHome(){
        props.backToHome("Podcast");
    }
    return <div className="primaryFont podcastContainer">
        <img src={Cross} className="podcastContainer__Cross" onClick={backToHome}></img>
        <div className="podcastFlex">
            <div className="podcastFlex__FlexLeft">
                <img src={JOSMLogo} className="JOSMlogo" alt=""></img>
                <div className="FlexLeft_BigText">One <br></br> Percent <br></br> Better <br></br> Everyday</div>
            </div>
            <div className="podcastFlex__FlexRight">
                <div className="FlexRight__TopBox">
                    <div className="TopBox_Content">
                        Calm yet Dynamic Podcast focused on
                        <br />making better choices in life everyday.
                        <br />Well studied and personally tested
                        <br />techniques that will make our life
                        <br />
                        <div className="RalewayBold">One Percent Better</div>
                    </div>
                </div>
                <div className="FlexRight__Notif">
                    Season 2<br></br>underway
                </div>
                <div className="FlexRight__Platforms">
                    <a target="_blank" href="https://bit.ly/3Tn788H"><img src={GPodcasts} alt=""></img></a>
                    <a target="_blank" href="https://youtube.com/channel/UCgZktIb4RuusN_YkLCuMVeA"><img src={Youtube} alt=""></img></a>
                    <a target="_blank" href="https://podcasts.apple.com/us/podcast/journal-of-small-musings/id1535693225"><img src={AppleMusic} alt=""></img></a>
                    <a target="_blank" href="https://open.spotify.com/show/7emnb0vklTayhxVgD0DINm?si=f227d10e20a64a3e"><img src={Spotify} alt=""></img></a>
                </div>
            </div>
        </div>
    </div>
}